export const mockCarrierList = function () {
  return [
    {
      id: 0,
      create_time: 1701239839929,
      update_time: 1701240379551,
      update_user: 1,
      create_user: 1,
      scene_id: 1,
      keycode: '低温冰箱',
      status: 0,
      typeId: 2,
      code: '',
      abnormal: 0,
      alarm_switch: 0,
      alarm_bind: 1,
      is_trace: 0,
      sample_value: '{"hum":[],"temp":[{"val":28.91,"code":"temp","min":20.0,"max":36.0,"rangeName":"81101常温","itemMap":[{"val":28.91,"no":"探头40540","catalog":0,"id":"0a39a1f0c5f64b76ae219177f92f227c","time":1701240057000,"type":2,"status":1}],"time":1701240244859,"isRange":0}]}',
      sample_strategy: 1,
      mode: 2,
      scopeId: 1,
      scopeName: '景瑞智能',
      structureId: 303,
      structureName: '测试多个点2',
      alarmTriggerList: [
        {
          id: 251,
          create_time: 1701240353650,
          update_time: 1702891766333,
          update_user: 135,
          create_user: 1,
          scene_id: 1,
          name: '景瑞测试触发器',
          reason: '0,1,2',
          type: 0,
          repeat_interval: 10,
          strategy: 1,
          interval_unit: 1
        }
      ]
    }
  ]
}
